import dynamic from 'next/dynamic';

import { HCP_VERIFICATION_MODAL_PORTS } from './hcp-verification-modal-ports';

// The package door stays out of the /_app chunk: both mounts lazy-load.
const HcpVerificationModalLazy = dynamic(
  () => import('@heidi/ads').then((m) => m.HcpVerificationModal),
  { ssr: false }
);
export const HcpVerificationModal = () => (
  <HcpVerificationModalLazy ports={HCP_VERIFICATION_MODAL_PORTS} />
);
export const HcpVerificationNotificationSource = dynamic(
  () => import('@heidi/ads').then((m) => m.HcpVerificationNotificationSource),
  { ssr: false }
);
